import React, {useContext, useState, Component} from 'react';
import { AuthContext } from "../Auth.js"
import EpicMenu from '../componentes/Menus/EpicMenu';
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import Actividad from '../componentes/Actividades/Actividad';
import NuevaActividad from '../componentes/Actividades/nuevaActividad';
import { Icon, Modal } from 'semantic-ui-react';
import formStyles from '../componentes/forms/form.module.css';
import {getCompanyCollection} from '../firebase';

export const Main =()=>{
    const { currentUser } = useContext(AuthContext)
	const [userRol] = useState(currentUser.rol)
    return (
        <section>
            <PaginaActividades userRol={userRol}/>
        </section>
    )
}

class PaginaActividades extends Component{
	constructor(props){
		super(props);
		this.addAct = this.addAct.bind(this);
		this.removeAct = this.removeAct.bind(this);
		this.app= firebase;
		this.database = null;

		this.state = {
			actividades: [],
			useModal: false,
            empRol:this.props.userRol,
		}
	}

	async componentDidMount(){
		this.database = await getCompanyCollection('Actividades')
		this.database.onSnapshot(querySnapshot =>{
			this.setState({actividades:[]})
			querySnapshot.forEach(doc=>{
				const previousAct = this.state.actividades;
				previousAct.push({
					id: doc.id,
					nombre: doc.data().nombre,
					categoria: doc.data().categoria,
					pagarpor: doc.data().pagarpor,
					precioMin: doc.data().precioMin,
					precioMid: doc.data().precioMid,
					precioMax: doc.data().precioMax,
					frecuencia: doc.data().frecuencia,
				})
				this.setState({
					actividades: previousAct
				})
			})
		})
	}

	addAct(actividad){ 
		return this.database.add({
			nombre: actividad.nombre,
			categoria: actividad.categoria,
			precioMin: parseFloat(actividad.precioMin),
			precioMid: parseFloat(actividad.precioMid),
			precioMax: parseFloat(actividad.precioMax),
			pagarpor: actividad.pagarpor,
		})
	}
	removeAct(actID){
		this.database.child(actID).remove();
	}
	modalAgregar = () => (
		<Modal
			className={formStyles.modal}
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Nueva Actividad</button>}>
			<Modal.Header>Registrar nueva actividad</Modal.Header>
			<Modal.Content>
				<NuevaActividad actividades={this.state.actividades} addAct={this.addAct} changeModal={this.changeUsModal} />
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
	render(){
		return (
		<div>
			<div className='header'>
				<EpicMenu />
				<div className='inline'>
					Actividades Registradas
				</div>
				<div className="addNew" ><this.modalAgregar /></div>
			</div>
			<div className="body tabla activitiesTableContainer">
				<table><tbody>
				<tr>
					<th>Nombre</th>
					{/*<th>Categoria</th>*/}
					<th>Dificultad Facil</th>
					<th>Dificultad Media</th>
					<th>Dificultad Alta</th>
					<th>Pagar por</th>
					<th></th>
				</tr>
				{
				this.state.actividades.map((actividad) => { 
					return (
						<tr key={actividad.id}><Actividad  
							rol={this.state.empRol}
							nombre={actividad.nombre}
							categoria={actividad.categoria}
							pagarpor={actividad.pagarpor}
							precioMin={actividad.precioMin}
							precioMid={actividad.precioMid}
							precioMax={actividad.precioMax}
							frecuencia={actividad.frecuencia}
							actID={actividad.id} 
							key={actividad.id} 
							removeAct ={this.removeAct}
						/></tr>
					)
				})
				}
				</tbody></table>
			</div>
			<div className="footer" >
				<div className="footer1" ></div>
				<div className="footer2" ></div>
			</div>
		</div>
		);
	}
}

export default Main
